export default __webpack_public_path__ + "static/media/1415 knife block B side.cac35e00.png";